import { Ref } from "react";

import TableBodyRow from "ds/components/Table/Row";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import Button from "ds/components/Button";
import useRowKeyboardNavigation from "ds/components/Table/hooks/useKeyboardNavigation/useRowKeyboardNavigation";
import { TableColumnMeta } from "ds/components/Table/types";
import useIntentModuleResources from "shared/IntentProject/useIntentModuleResources";

import useIntentProjectResourcesHierarchyStore from "../useResourcesHierarchyStore";
import { ResourcesServiceRow } from "../tableDataSelectors";
import { INTENT_PROJECT_MODULE_RESOURCES_PER_PAGE } from "../constants";
import styles from "./styles.module.css";

type IntentProjectResourcesTableServiceRowProps = {
  row: ResourcesServiceRow;
  columns: TableColumnMeta[];
  isFirstColumnPinned: boolean;
  measureRef: Ref<HTMLDivElement>;
  dataIndex: number;
};

const IntentProjectResourcesTableServiceRow = ({
  row,
  columns,
  isFirstColumnPinned,
  measureRef,
  dataIndex,
}: IntentProjectResourcesTableServiceRowProps) => {
  const keyboardProps = useRowKeyboardNavigation({ isGroup: false });
  const { fetchModuleResources, loading } = useIntentModuleResources(row.intentProjectId);
  const loadGroupChildren = useIntentProjectResourcesHierarchyStore(
    (state) => state.loadGroupChildren
  );

  const onLoadMore = () =>
    loadGroupChildren(row.groupId, ({ after }) =>
      fetchModuleResources(row.groupId, INTENT_PROJECT_MODULE_RESOURCES_PER_PAGE, after)
    );

  return (
    <TableBodyRow
      {...keyboardProps}
      ref={measureRef}
      dataIndex={dataIndex}
      className={styles.serviceRow}
      virtualized
    >
      {columns.map((column, i) => (
        <TableSimpleCell
          key={`${row.id}-${column.id}`}
          id={`${row.id}-${column.id}`}
          stickyLeft={i === 0 && isFirstColumnPinned}
          stickyRight={i === columns.length - 1}
          className={i === 0 ? styles.serviceCell : undefined}
        >
          {i === 0 && (
            <Button variant="secondary" onPress={onLoadMore} loading={loading} size="medium">
              Load {INTENT_PROJECT_MODULE_RESOURCES_PER_PAGE} more resources
            </Button>
          )}
        </TableSimpleCell>
      ))}
    </TableBodyRow>
  );
};

export default IntentProjectResourcesTableServiceRow;
